module.exports = __webpack_public_path__ + "img/ico_payment_default.ece0d4d8.png";